import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesOps {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `producao`
 * (`apps/api/src/modules/producao/ops.routes.ts`, seed original da
 * migration `004`): `admin` (curinga `*`) e o papel `producao` têm
 * `ler`/`criar`/`atualizar`/`excluir` — esta tela só usa `ler`/
 * `atualizar` (mover etapa, atribuir técnico — não existe `criar` via
 * HTTP, OPS nasce só do listener). Nenhum outro papel tem qualquer
 * permissão sobre este recurso (`PRODUCT.md` 4.2/4.6/4.7 — "Não
 * acessa: Produção"). Usado apenas para decidir o que mostrar na UI —
 * a autorização real é sempre revalidada pelo backend.
 */
export function permissoesOps(papel: PapelUsuario): PermissoesOps {
  if (papel === 'admin' || papel === 'producao') {
    return { ler: true, atualizar: true };
  }
  return { ler: false, atualizar: false };
}
